"use client"
import { SharedImageModal } from "@/components/shared-image-modal"
import { PortfolioGrid } from "@/components/portfolio-grid"
import { Footer } from "@/components/footer"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs"
import { useState } from "react"


const PORTFOLIO_R2 = process.env.NEXT_PUBLIC_R2_PUBLIC_DOMAIN || "media.akilesecosystem.com"



// Image data for each stage
const stageImages = {
  stage1: [
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/tech-spiral-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/tech-spiral-main.png`, alt: "tech-spiral"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-wood/hombres-de-negocios-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-wood/hombres-de-negocios-main.png`, alt: "hombres-de-negocios"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/la-calle-esta-muerta-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/la-calle-esta-muerta-main.png`, alt: "la-calle-esta-muerta"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/sociedad-sucia-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/sociedad-sucia-main.png`, alt: "sociedad-sucia"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-wood/atardecer-con-palmeras-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-wood/atardecer-con-palmeras-main.png`, alt: "sociedad-sucia"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bucalemu-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bucalemu-main.png`, alt: "Bucalemu"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/compo-madera-3-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/compo-madera-3-main.png`, alt: "compo-madera-3"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/compo-madera-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/compo-madera-main.png`, alt: "compo-madera"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-de-madera-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-de-madera-main.png`, alt: "mandala-de-madera"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/dragones-de-america-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/dragones-de-america-main.png`, alt: "dragones-de-america"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/smoking-monkey-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/smoking-monkey-main.png`, alt: "smoking-monkey"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/mural/mural-concon-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/mural/mural-concon-main.png`, alt: "mural-concon"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/piano-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/piano-main.png`, alt: "piano"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/selva-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/selva-main.png`, alt: "selva"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/mural/paco-malo-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/mural/paco-malo-main.png`, alt: "paco-malo"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/ruquinoa-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/ruquinoa-main.png`, alt: "ruquinoa"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/dragon-de-la-tecnologia-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/dragon-de-la-tecnologia-main.png`, alt: "dragon-de-la-tecnologia-"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/nobody-can-do-it-like-you-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/nobody-can-do-it-like-you-main.png`, alt: "nobody-can-do-it-like-you"
    },
],

  stage2: [
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/auyama-ajies-y-topochos-2-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/auyama-ajies-y-topochos-2-main.png`, alt: "auyama-ajies-y-topochos-2"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/fragmentosde-vida-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/fragmentosde-vida-main.png`, alt: "fragmentosde-vida"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/hexaedro-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/hexaedro-main.png`, alt: "hexaedro"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-agua-y-fuego-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-agua-y-fuego-main.png`, alt: "mandala-agua-y-fuego"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-de-madera-2-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-de-madera-2-main.png`, alt: "mandala-de-madera-2"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/misterios-del-mar-4-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/misterios-del-mar-4-main.png`, alt: "misterios-del-mar-4"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/multiples-1-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/multiples-1-main.png`, alt: "multiples"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/recuerdos-del-mar-3-triptico-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/recuerdos-del-mar-3-triptico-main.png`, alt: "recuerdos-del-mar-3-triptico"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/tomates-margaritenos-y-aguacate-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/tomates-margaritenos-y-aguacate-main.png`, alt: "tomates-margaritenos-y-aguacate"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/dodecaedro-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/dodecaedro-main.png`, alt: "dodecaedro"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/humanae-creaturae-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/humanae-creaturae-main.png`, alt: "humanae-creaturae"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-gravedad-1-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/mandala-gravedad-1-main.png`, alt: "mandala-gravedad-1"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-wood/marina-sobre-madera-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-wood/marina-sobre-madera-main.png`, alt: "marina-sobre-madera"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/sinergia-diptico-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/sinergia-diptico-main.png`, alt: "sinergia-diptico"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/diptico-agua-y-fuego-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/diptico-agua-y-fuego-main.png`, alt: "diptico-agua-y-fuego"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/nucleo-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/nucleo-main.png`, alt: "nucleo"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/penero-grafiteao-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/penero-grafiteao-main.png`, alt: "dodecaedro"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frame-azul-naranja-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frame-azul-naranja-main.png`, alt: "mirror-frame-azul-naranja"
    },

  ],
  stage3: [
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/infinito-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/infinito-main.png`, alt: "infinito"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/interdimensional-marea-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/interdimensional-marea-main.png`, alt: "interdimensional-marea"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/mural/piso-reliquias-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/mural/piso-reliquias-main.png`, alt: "piso-reliquias"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bituaya-margaritena-1-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bituaya-margaritena-1-main.png`, alt: "bituaya-margaritena-1"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bituaya-margaritena-2-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bituaya-margaritena-2-main.png`, alt: "bituaya-margaritena-2"
    },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bituaya-margaritena-4-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/bituaya-margaritena-4-main.png`, alt: "bituaya-margaritena-4"
      },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frames-1-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frames-1-main.png`, alt: "mirror-frames-1"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frames-4-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frames-4-main.png`, alt: "mirror-frames-4"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frame-naranja-azul-rojo-blanco-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mirror-frame-naranja-azul-rojo-blanco-main.png`, alt: "mirror-frame-naranja-azul-rojo-blanco"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/aquarius-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/aquarius-main.png`, alt: "aquarius"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/caracas-abstracta-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/caracas-abstracta-main.png`, alt: "caracas-abstracta"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/atardecer-2-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/atardecer-2-main.png`, alt: "atardecer-2"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/horizonte-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/horizonte-main.png`, alt: "horizonte"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/panorama-margariteno-1-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/panorama-margariteno-1-main.png`, alt: "panorama-margariteno-1"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/auyama-ajies-y-topochos-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/auyama-ajies-y-topochos-main.png`, alt: "auyama-ajies-y-topochos"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/furniture-art/sillon-trono-1-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/furniture-art/sillon-trono-1-main.png`, alt: "sillon-trono-1"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/assemblage/scape-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/assemblage/scape-main.png`, alt: "scape"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mesa-f1-2-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/furniture-art/mesa-f1-2-main.png`, alt: "mesa-f1-2"
    },

  ],
  stage4: [
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/oil-vecs-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/oil-vecs-main.png`, alt: "oil-vecs"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digitization/iris-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digitization/iris-main.png`, alt: "iris"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/three-d-model/marina-de-peneros-model-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/three-d-model/marina-de-peneros-model-main.png`, alt: "marina-de-peneros-model"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/serenidad-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/serenidad-main.png`, alt: "serenidad"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/felicidad-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/felicidad-main.png`, alt: "ants-bridge"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/sunrays-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/sunrays-main.png`, alt: "sunrays"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/three-d-model/recycled-woods-model-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/three-d-model/recycled-woods-model-main.png`, alt: "recycled-woods-model"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/animation/exiliado-animation-gallery-3-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/animation/exiliado-animation-gallery-3.jpg`, alt: "exiliado-animation-gallery-3"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/animation/exiliado-animation-gallery-2-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/animation/exiliado-animation-gallery-2.jpg`, alt: "exiliado-animation-gallery-2"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/animation/exiliado-animation-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/animation/exiliado-animation-main.png`, alt: "exiliado-animation-gallery-1"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/three-d-model/palo-de-agua-kitchen-model-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/three-d-model/palo-de-agua-kitchen-model-main.png`, alt: "palo-de-agua-kitchen-model"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/animation/taxi-del-futuro-animation-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/animation/taxi-del-futuro-animation-main.png`, alt: "taxi-del-futuro"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/ants-bridge-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/ants-bridge-main.png`, alt: "ants-bridge"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/jaguar-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/jaguar-main.png`, alt: "jaguar"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/humpback-whale-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/humpback-whale-main.png`, alt: "humpback-whale"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/earthquake-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/earthquake-main.png`, alt: "earthquake"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/crystals-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/crystals-main.png`, alt: "crystals"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/yesterday-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/yesterday-main.png`, alt: "yesterday"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/projects/remares/16-cab-monkey-green-roof-remares-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/projects/remares/16-cab-monkey-green-roof-remares.png`, alt: "16-cab-monkey-green-roof-remares"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/projects/remares/17-bird-remares-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/projects/remares/17-bird-remares.png`, alt: "17-bird-remares"
      },
      {
        thumbSrc: `https://${PORTFOLIO_R2}/projects/remares/7-carpentry-equipment-remares-thumb.jpg`,
        fullSrc:  `https://${PORTFOLIO_R2}/projects/remares/7-carpentry-equipment-remares.png`, alt: "7-carpentry-equipment-remares"
      },

  ],
  stage5: [
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/baby-buddha-2-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/baby-buddha-2-main.png`, alt: "baby-buddha-2"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/el-capo-chino-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/el-capo-chino-main.png`, alt: "el-capo-chino"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/elephant-king-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/elephant-king-main.png`, alt: "elephant-king"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/la-fee-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/la-fee-main.png`, alt: "la-fee"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/mushland-2-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/mushland-2-main.png`, alt: "mushland-2"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/the-garden-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/the-garden-main.png`, alt: "the-garden"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/kill-bill-toucan-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/kill-bill-toucan-main.png`, alt: "kill-bill-toucan"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/bitcoin-growing-shiny-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/bitcoin-growing-shiny-main.png`, alt: "bitcoin-growing-shiny"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/el-spot-mural-digital-art-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/el-spot-mural-digital-art-main.png`, alt: "el-spot-mural-digital-art"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/mush-doors-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/mush-doors-main.png`, alt: "mush-doors "
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/growing-roots-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/growing-roots-main.png`, alt: "growing-roots"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/abstract-sunset-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/artwork/acrylic-on-canvas/abstract-sunset-main.png`, alt: "abstract-sunset"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digital-art/lightning-ostrich-bitcoin-jungle-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digital-art/lightning-ostrich-bitcoin-jungle-main.png`, alt: "lightning-ostrich-bitcoin-jungle"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digitization/temascal-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digitization/temascal-main.png`, alt: "temascal"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/items/digital/digitization/mush-cascade-thumb.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/items/digital/digitization/mush-cascade-main.png`, alt: "mush-cascade"
    },

  ],
  expositions: [
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-artucs-1-sample-1.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-artucs-1-sample-1.jpg`, alt: "artucs-1 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-artucs-2-sample-2.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-artucs-2-sample-2.jpg`, alt: "artucs-2 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-colosus-sample-3.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-colosus-sample-3.jpg`, alt: "expo-colosus-sample-3 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-museo-alejandro-otero-sample-4.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-museo-alejandro-otero-sample-4.jpg`, alt: "expo-museo-alejandro-otero-sample-4 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-bogota-1-sample-5.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-bogota-1-sample-5.jpg`, alt: "expo-bogota-1-sample-5 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-bogota-2-sample-6.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-bogota-2-sample-6.jpg`, alt: "expo-bogota-2-sample-6 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-bogota-3-sample-7.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-bogota-3-sample-7.jpg`, alt: "expo-bogota-3-sample-7 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetros-1-sample-8.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetros-1-sample-8.jpg`, alt: "expo-milimetros-1-sample-8 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetros-2-sample-9.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetros-2-sample-9.jpg`, alt: "expo-milimetros-2-sample-9 - collective exhibition"
    },
    { thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetros-3-sample-10.jpg`,
       fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetros-3-sample-10.jpg`, alt: "expo-milimetros-3-sample-10 - collective exhibition"
     },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetro-4-samples-11.jpg`,
      fullSrc:  `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-milimetro-4-samples-11.jpg`, alt: "expo-milimetros-4-sample-11 - collective exhibition"
    },
   {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-formato-minimo-sample-12.jpg`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/expos-samples/expo-formato-minimo-sample-12.jpg`, alt: "formato-minimo-2014 - collective exhibition"
    },
    {
      thumbSrc: `https://${PORTFOLIO_R2}/events/expos-old/a-la-deriva-2017/a-la-deriva-expo-thumb.png`,
      fullSrc: `https://${PORTFOLIO_R2}/events/expos-old/a-la-deriva-2017/a-la-deriva-expo-thumb.png`, alt: "A la Deriva Individual Exhibition - Thumb"
    }
    
  ]
}

export default function PortfolioPage() {
  const [selectedImage, setSelectedImage] = useState<{src: string; alt: string} | null>(null)
  const [activeTab, setActiveTab] = useState("stage5")

  return (
    <div className="min-h-screen bg-background text-foreground dark:bg-black dark:text-white pt-16 flex flex-col transition-colors duration-300">


      <SharedImageModal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        imageSrc={selectedImage?.src}
        imageAlt={selectedImage?.alt}
      />

      <main className="container mx-auto px-6 py-8 flex flex-col">
        {/* Portfolio Tabs */}
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full order-1 flex flex-col">
          <TabsList className="grid w-full grid-cols-6 mb-8 order-1">
            <TabsTrigger value="stage5">Stage 5</TabsTrigger>
            <TabsTrigger value="stage4">Stage 4</TabsTrigger>
            <TabsTrigger value="stage3">Stage 3</TabsTrigger>
            <TabsTrigger value="stage2">Stage 2</TabsTrigger>
            <TabsTrigger value="stage1">Stage 1</TabsTrigger>
            <TabsTrigger value="expositions">Expositions</TabsTrigger>
          </TabsList>

          <div className="order-2 mt-12">
            <TabsContent value="stage5" className="mt-0">
              <div className="space-y-4">
                <div className="border-l-4 border-blue-500 pl-4">
                  <h2 className="text-2xl font-bold text-foreground uppercase tracking-tight">STAGE 5 (2023-Present)</h2>
                  <p className="text-muted-foreground">Organic Imaginary and Dope Crew Series</p>
                </div>
                <PortfolioGrid images={stageImages.stage5} onImageClick={setSelectedImage} />
              </div>
            </TabsContent>

            <TabsContent value="stage4" className="mt-0">
              <div className="space-y-4">
                <div className="border-l-4 border-green-500 pl-4">
                  <h2 className="text-2xl font-bold text-foreground uppercase tracking-tight">STAGE 4 (2017-2022)</h2>
                  <p className="text-muted-foreground">Digital Art, 3D Models, and Architecture</p>
                </div>
                <PortfolioGrid images={stageImages.stage4} onImageClick={setSelectedImage} />
              </div>
            </TabsContent>

            <TabsContent value="stage3" className="mt-0">
              <div className="space-y-4">
                <div className="border-l-4 border-yellow-500 pl-4">
                  <h2 className="text-2xl font-bold text-foreground uppercase tracking-tight">STAGE 3 (2015-2017)</h2>
                  <p className="text-muted-foreground">Furniture Art and Mirror Frames</p>
                </div>
                <PortfolioGrid images={stageImages.stage3} onImageClick={setSelectedImage} />
              </div>
            </TabsContent>

            <TabsContent value="stage2" className="mt-0">
              <div className="space-y-4">
                <div className="border-l-4 border-orange-500 pl-4">
                  <h2 className="text-2xl font-bold text-foreground uppercase tracking-tight">STAGE 2 (2013-2014)</h2>
                  <p className="text-muted-foreground">Recycled Wood Assemblages and Mandalas</p>
                </div>
                <PortfolioGrid images={stageImages.stage2} onImageClick={setSelectedImage} />
              </div>
            </TabsContent>

            <TabsContent value="stage1" className="mt-0">
              <div className="space-y-4">
                <div className="border-l-4 border-red-500 pl-4">
                  <h2 className="text-2xl font-bold text-foreground uppercase tracking-tight">STAGE 1 (2010-2012)</h2>
                  <p className="text-muted-foreground">Murals, Aerography, Screen Printing, and Recycling Art</p>
                </div>
                <PortfolioGrid images={stageImages.stage1} onImageClick={setSelectedImage} />
              </div>
            </TabsContent>

            <TabsContent value="expositions" className="mt-0">
              <div className="space-y-4">
                <div className="border-l-4 border-indigo-500 pl-4">
                  <h2 className="text-2xl font-bold text-foreground uppercase tracking-tight">EXPOSITIONS</h2>
                  <p className="text-muted-foreground">Individual Shows and Museum Exhibitions</p>
                </div>
                <PortfolioGrid images={stageImages.expositions} onImageClick={setSelectedImage} />
              </div>
            </TabsContent>
          </div>

          {/* Hero Section moved below */}
          <section className="text-center py-24 border-t border-border/50 order-3 mt-24">
            <h1 className="text-5xl md:text-8xl font-black tracking-tighter mb-6 text-foreground uppercase">
              Portfolio
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed font-medium">
              An evolutionary journey through analog matter and digital realms. From Margarita Island to the Pacific Coast.
            </p>
          </section>
        </Tabs>
      </main>

      <Footer />
    </div>
  )
}
